import React from "react";
import {Tooltip, TooltipProps} from "@material-ui/core";
import clsx from "clsx";
import useStyles from "./styles";

function FfairTooltip({children, ...props}: TooltipProps) {
  const classes = useStyles();
  return (
    <Tooltip
      {...props}
      classes={{
        ...props.classes,
        popper: clsx(classes.tooltipRoot, props.classes?.tooltip),
      }}
    >
      {children}
    </Tooltip>
  );
}

export default FfairTooltip;
